// URL を収集する処理(Firebase Analytics など)より先に実行する必要があるため、必ず最初に import する
import '@user/pages/GroupMemberInvitationPage/stashInvitationTokenOnLoad';
import './styles/tailwind.css';

import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import 'reflect-metadata';
import '@framework/firebase/setup';
import '@framework/i18n/i18n';

// 各種コンテキストの binding は、 reflect-metadata, framework をインポートした後に並べる
import './view-model/bind';

import 'github-markdown-css/github-markdown-light.css';
import './index.css';
import { App } from 'App';
import Modal from 'react-modal';
import { emulatorEnabled, setupFirebaseEmulator } from './emulatorConfiguration';
import * as Sentry from '@sentry/react';
import { BuildInfo } from '@config/build-info';
import { getClientId } from '@framework/app';
import { LocalOrigins, userWebappHostMapping } from '@config/localOrigins';

// NOTE: admin側は別に初期化している設定があるので注意
Sentry.init({
  dsn: 'https://d1c90a3fbcd00feb39967c10c1db822d@o949091.ingest.us.sentry.io/4509603506094080',
  sendDefaultPii: true,
  release: `app-${BuildInfo.DATE}`,
  environment: process.env.GOOGLE_CLOUD_PROJECT || 'dev',
  enabled: process.env.NODE_ENV === 'production',
  integrations: [
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),
  ],
});

Sentry.setTag('clientId', getClientId());

if (window && window.location) {
  const hostname = window.location.hostname;

  // admin.balus.dev または admin.balus.app のドメインで、
  // 一般ユーザ向けのフロントエンドがロードされた時に、管理者向けアプリ側にリダイレクトする。
  if (hostname === 'admin.balus.dev' || hostname === 'admin.balus.app') {
    window.location.href = `https://${hostname}/admin/console`;
  }

  const host = window.location.host;

  // ローカル開発環境では、管理画面のパスにアクセスされたらadmin用のホストにリダイレクトする
  {
    const from = `${LocalOrigins.webapp}/admin`;
    if (location.href.startsWith(from)) {
      window.location.href = location.href.replace(from, `${LocalOrigins.adminWebapp}/admin`);
    }
  }

  // ユーザ画面用エントリーポイントに対して管理画面用ポートや 127.0.0.1 経由でアクセスがあった場合には、
  // ユーザ画面用のホストにリダイレクトする
  if (userWebappHostMapping[host]) {
    window.location.href = window.location.href.replace(host, userWebappHostMapping[host]);
  }
}

// エミュレーターセットアップ
if (emulatorEnabled()) {
  setupFirebaseEmulator();
}

// react-modal に対して、アプリケーション要素の情報を設定する。
// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container, {
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
